import React from "react";
import Col from "react-bootstrap/Col";
import Alert from "react-bootstrap/Alert";
import Spinner from "react-bootstrap/Spinner";
import IssueListItem from "../IssueListItem/IssueListItem";
import "./IssueList.css";
import memoizeOne from "memoize-one";

class IssueList extends React.Component {
  constructor(props) {
    super(props);
    this.state = { currentListCount: 0, renderingID: 0 };

    this.filter = memoizeOne((issues, keyword) => {
      const filteredIssues = issues.filter(anIssue => {
        const idContained =
          anIssue.issue != null &&
          anIssue.issue.toLowerCase().includes(keyword);

        return idContained;
      });

      return filteredIssues.sort((a, b) => b.created_at - a.created_at);
    });
  }

  componentDidMount() {
    this.recursive(this.state.renderingID);
  }

  recursive(renderingID) {
    setTimeout(() => {
      if (this.state.renderingID !== renderingID) {
        return;
      }

      this.setState({
        currentListCount: this.state.currentListCount + 1
      });

      const filteredList = this.filter(
        this.props.issues,
        this.props.keyword.toLowerCase()
      );

      if (this.state.currentListCount < filteredList.length) {
        this.recursive(renderingID);
      }
    }, 0);
  }

  static getDerivedStateFromProps(props, state) {
    if (
      props.issues !== state.prevIssues ||
      props.keyword !== state.prevKeyword
    ) {
      return {
        currentListCount: 0,
        renderingID: state.renderingID + 1,
        prevIssues: props.issues,
        prevKeyword: props.keyword
      };
    }

    return null;
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.issues !== prevProps.issues ||
      this.props.keyword !== prevProps.keyword
    ) {
      this.recursive(this.state.renderingID);
    }
  }

  render() {
    const { isLoading, issues, errMsg, keyword } = this.props;
    const lowerKeyword = keyword.toLowerCase();

    if (isLoading) {
      return (
        <Col className="issue_spinner_container">
          <Spinner animation="grow" />
        </Col>
      );
    } else if (errMsg != null) {
      return (
        <Col>
          <Alert variant="danger">{errMsg}</Alert>
        </Col>
      );
    } else {
      const filteredList = this.filter(issues, lowerKeyword);

      const renderingFilteredList = filteredList.slice(
        0,
        this.state.currentListCount + 1
      );

      return (
        <React.Fragment>
          {renderingFilteredList.map(issue => (
            <Col key={issue.id} xs={12} sm={6} md={4} lg={3} xl={3}>
              <IssueListItem
                isAdmin={this.props.isAdmin}
                handleDelete={this.props.handleDelete}
                issue={issue}
                currentIssueID={this.props.currentIssueID}
              />
            </Col>
          ))}
        </React.Fragment>
      );
    }
  }
}

export default IssueList;
